import { useConfig } from 'config/use-config';
import { isEmptyProfile } from 'stores/pet-profile-new/utils/is-empty-profile';
import { useRootStore } from 'stores/use-root-store';

/**
 * In case if pet profile feature is switch on it checks if petProfile is not empty based on
 * See {@link https://petsdeli.atlassian.net/wiki/spaces/PT/pages/2581954577/Is+Pet+Profile+Empty+definition | Is Pet Profile Empty definition}
 */
export function useIsPetProfileExist(): boolean {
  const petProfile = useRootStore((store) => store.currentPetProfile);
  const { featureFlags } = useConfig();
  const petProfileFeatureFlag = featureFlags.petProfile;
  return petProfileFeatureFlag && !isEmptyProfile(petProfile);
}
